var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NsOktaPassword',{staticClass:"df-password",attrs:{"translations":_vm.translations,"rules-on":true,"username":_vm.username},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }